import { createContext, useContext } from "react";

export type RolesContent = {
  roles: { [key: string]: boolean | string };
  setRoles?: (c: any) => void;
};
export const MyRolesContext = createContext<RolesContent>({
  roles: {},
  setRoles: () => {},
});

export const useRolesContext = () => useContext(MyRolesContext);
